import { ApiUtility } from "../../Utilities/ApiUtility.axios";

class GstService {
  // ------- GST Api ---------

  //  https://localhost:7142/V1/API/Acc_Gst
  // https: //localhost:7142/V1/API/Acc_Gst/1

  private route = "/V1/API/Billing/Acc_Gst";

  postGst = (params: any, id?: number) =>
    ApiUtility.post(`${this.route}/${id ? id : ""}`, params);

  getGSTList = (
    start?: number,
    length?: number,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    isActive?: boolean
  ) =>
    ApiUtility.getResult(`${this.route}`, {
      start,
      length,
      sortCol,
      sortDir,
      search,
      isActive,
    });
}
export default new GstService();
